<i18n src="@/locales/views/agro_exporter/production/basic_container_export/show_exportation.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/exportation.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<template>
  <go-back-link :text="$t('labels.go-back-link')" :name='routeName("show_process_exportations")'
    :params="{ agro_exporter_process_id: agro_exporter_process_id }" />

  <agro-exporter-process-header :agro_exporter_process_id="agro_exporter_process_id" />

  <alert-danger :errors_data="std_err" />

  <template v-if="load_data_general">
    <div  class="mt-8">
      <div class="panel">
        <div class="panel-header">
          <h3 class="panel-header-title">
            {{ $t("labels.title") }}
          </h3>
        </div>

        <div class="panel-body">
          <div class="space-y-8 divide-y divide-gray-200" v-if="exportation">
            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <dt class="label-data">
                  <template v-if="(exportation.exportation_type_id == 0)">
                    {{ $t("model.exportation.booking_code_0") }}
                  </template>
                  <template v-else-if="(exportation.exportation_type_id == 1)">
                    {{ $t("model.exportation.booking_code_1") }}
                  </template>
                </dt>
                <dd class="content-data">
                  {{ exportation.booking_code }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.exportation_type") }}
                </dt>
                <dd class="content-data">
                  <exportation-type :exportation_type_id="exportation.exportation_type_id" />
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.week") }}
                </dt>
                <dd class="content-data">
                  {{ exportation.week }}
                </dd>
              </div>
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.status") }}
                </dt>
                <dd class="content-data">
                  <exportation-status :status_id="exportation.status_id" />
                </dd>
              </div>
            </div>
            <div class="pt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-6">
                <div class="table-first-container" v-if="exportation.containers?.length > 0">
                  <div class="table-second-container">
                    <div class="table-third-container">
                      <table class="table">
                        <thead class="table-header">
                          <tr>
                            <th scope="col" class="table-header-cell">
                              {{ $t("model.exportation.container") }}
                            </th>
                            <th scope="col" class="table-header-cell">
                              {{ $t("model.container.packing_house") }}
                            </th>
                            <th scope="col" class="table-header-cell">
                              {{ $t("model.container.producers") }}
                            </th>
                            <th scope="col" class="table-header-cell">
                              {{ $t("model.container.customer") }}
                            </th>
                          </tr>
                        </thead>
                        <tbody class="table-body">
                          <tr class="table-row" v-for="container in exportation.containers" :key="container.id">
                            <td class="table-cell">
                              {{ container.container_code }}
                            </td>
                            <td class="table-cell">
                              {{ container.packing_house?.name }}
                            </td>
                            <td class="table-cell"></td>
                            <td class="table-cell">
                              {{ container.customer?.name }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <alert-warning v-else :warning_data="{
                  title: $t('labels.not_containers'),
                }" />
              </div>
            </div>

            <div class="pt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.origin_export") }}
                </dt>
                <dd class="content-data">
                  {{ exportation.origin_export?.name }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.destination_export") }}
                </dt>
                <dd class="content-data">
                  {{ exportation.destination_export?.name }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.departured_at") }}
                </dt>
                <dd class="content-data">
                  {{ dateFormatter(exportation.departured_at) }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.arrived_at") }}
                </dt>
                <dd class="content-data">
                  {{ dateFormatter(exportation.arrived_at) }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.shipping_line") }}
                </dt>
                <dd class="content-data">
                  {{ exportation.shipping_line?.name }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.ship") }}
                </dt>
                <dd class="content-data">
                  {{ exportation.ship }}
                </dd>
              </div>
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.exportation.dam_code") }}
                </dt>
                <dd class="content-data">
                  {{ exportation.dam_code }}
                </dd>
              </div>
            </div>
          </div>
        </div>
        <div class="panel-footer">
          <div class="panel-footer-actions">
            <button type="button" @click.prevent="downloadReportExportation()" class="btn-white">
              <i class="fa-solid fa-file-excel"></i>
              <span class="space-icon"></span>{{ $t("labels.exportation_report_button") }}
            </button>

            <span class="space-actions"></span>
            <button v-if="
              exportation?.containers?.length == 0 &&
              exportation?.export_invoices?.length == 0
            " type="button" @click.prevent="destroyExportation()" class="btn-destroy">
              <i class="fa-solid fa-xmark pt-0.5"></i>
              <span class="space-icon"></span>{{ $t("labels.destroy_button_label") }}
            </button>
            <button v-else type="button" class="btn-destroy-disabled">
              <i class="fa-solid fa-xmark pt-0.5"></i>
              <span class="space-icon"></span>{{ $t("labels.destroy_button_label") }}
            </button>
            <span class="space-actions" />
            <destroy-button v-if="!proc_button_destroy" :disabled_button="false" @destroyEvent="destroyExportation()"
              :label="$t('labels.destroy_button_label')" :title="$t('labels.destroy_button_title')"
              :message="$t('labels.destroy_button_message')" :label_confirm="$t('labels.destroy_button_label_confirm')" />
            <destroy-button-processing v-else :label="$t('labels.destroy_button_label')" />
            <span class="space-actions"></span>
            <edit-button @click.prevent="goToEditExportation()" :label="$t('labels.edit_button')" />
          </div>
        </div>
      </div>
    </div>

    <div class="my-8" v-if="(exportation_files.length > 0)">
      <div class="flex justify-between mt-8 mb-2">
        <h3 class="items-center">
          <div class="panel-header-title">Adjuntos</div>
        </h3>
        <uploader-attachment :exportation_files="exportation_files" :exportation_id="exportation_id"
          @new="(value) => this.exportation_attachments.push(value)"></uploader-attachment>
      </div>
      <div class="mt-8 flex flex-col">
        <div class="table-first-container">
          <div class="table-second-container">
            <div class="table-third-container">
              <table class="table">
                <!-- <thead class="table-header">
                    <tr>
                      <th scope="col" class="table-header-cell">Archivo</th>
                      <th scope="col" class="table-header-cell"></th>
                    </tr>
                  </thead> -->
                <thead class="table-header">
                  <tr>
                    <th scope="col" class="table-header-cell">
                      {{
                      $t(
                      "model.exportation.exportation_attachments.exporter_process_exportation_file"
                      )
                      }}
                    </th>
                    <th scope="col" class="table-header-cell">
                      {{
                      $t(
                      "model.exportation.exportation_attachments.exportation_attach"
                      )
                      }}
                    </th>
                    <th scope="col" class="table-header-cell"></th>
                  </tr>
                </thead>
                <tbody class="table-body">
                  <tr class="table-row" v-for="attachment in exportation_attachments" :key="attachment.id">
                    <td class="table-cell">
                      {{ attachment.exporter_process_exportation_file.name }}
                    </td>
                    <td class="table-cell-main">
                      {{ attachment.exportation_attach.blob.filename }}
                    </td>
                    <td class="table-cell-action">
                      <i class="fa-solid fa-spinner" v-if="attachment.requesting"></i>
                      <template v-else>
                        <button class="btn-destroy" @click.prevent="
                          destroyExportationAttachment(attachment)
                        ">
                          <i :class="[
                            'fa-solid  ',
                            attachment.downloading
                              ? ' fa-sppiner'
                              : ' fa-trash',
                          ]"></i>
                        </button>
                        <span class="space-actions hidden sm:inline"></span>
                        <button class="btn-white inline-flex" @click.prevent="
                          downloadExportationAttachment(attachment)
                        ">
                          <i :class="[
                            'fa-solid ',
                            attachment.downloading
                              ? ' fa-sppiner'
                              : ' fa-download',
                          ]"></i>
                        </button>
                      </template>
                    </td>
                  </tr>
                </tbody>
                <!-- <tbody class="table-body">
                  <template
                    v-for="exportation_file in exportation_files"
                    :key="exportation_file.id"
                  >
                    <tr class="table-row">
                      <td class="table-header-cell bg-gray-50" colspan="3">
                        <div class="flex justify-between">
                          <h3 class="flex items-center">
                            {{ exportation_file.name }}
                          </h3>
                        </div>
                      </td>
                    </tr>
                    <tr
                      v-if="
                        exportationAttachments(exportation_file.id).length == 0
                      "
                      class="table-row"
                    >
                      <td class="table-cell">
                        {{ $t("labels.no_exportation_attachments") }}
                      </td>
                    </tr>
                    <tr
                      class="table-row"
                      v-for="attach in exportationAttachments(
                        exportation_file.id
                      )"
                      :key="attach.id"
                    >
                      <td class="table-cell">
                        {{ attach.exportation_attach.blob.filename }}
                      </td>
                      <td class="table-cell-action">
                        <button
                          class="btn-destroy"
                          @click.prevent="destroyExportationAttachment(attach)"
                        >
                          <i class="fa-solid fa-trash"></i>
                        </button>
                        <span class="space-actions hidden sm:inline"></span>
                        <button
                          class="btn-white inline-flex"
                          @click.prevent="downloadExportationAttachment(attach)"
                        >
                          <i
                            :class="[
                              'fa-solid  ',
                              attach.downloading ? ' fa-spinner' : ' fa-download',
                            ]"
                          ></i>
                        </button>
                      </td>
                    </tr>
                  </template>
                </tbody> -->
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <loading-message v-else/>
</template>

<script>
import BasicContainerExportMERequester from "@/views/agro_exporter/requesters/production/basic_container_export/manage_exportation.js";
import AgroExporterProcessHeader from "@/components/views/agro_exporter/production/basic_container_export/AgroExporterProcessHeader.vue";
import ExportationStatus from "@/components/views/agro_exporter/production/shared/exportation/ExportationStatus.vue";
import ExportationType from "@/components/views/agro_exporter/production/shared/exportation/ExportationType.vue";
import UploaderAttachment from "@/components/views/agro_exporter/production/basic_container_export/UploaderAttachment.vue";

export default {
  name: "AEProductionBasicContainerExportNewContainer",
  components: {
    AgroExporterProcessHeader,
    ExportationStatus,
    UploaderAttachment,
    ExportationType,
  },
  props: ["agro_exporter_process_id", "exportation_id", "agro_exporter_id"],
  data() {
    return {
      proc_button_destroy: false,
      load_data_general: false,
      exportation: null,
      exportation_files: [],
      exportation_attachments: [],
    };
  },
  methods: {
    fetchExportation: async function () {
      let response = await BasicContainerExportMERequester.fetchExportation(
        this.exportation_id
      );
      this.exportation = response.data;
      this.load_data_general = true;
      /*
      this.booking_code = response.data.booking_code;
      this.dam_code = response.data.dam_code;
      this.departured_at = response.data.departured_at;
      this.arrived_at = response.data.arrived_at;
      this.origin_export = response.data.origin_export;
      this.destination_export = response.data.destination_export;
      this.shipping_line = response.data.shipping_line;
      this.ship = response.data.ship;
      this.week = response.data.week;
      this.containers = response.data.containers;
      this.status_id = response.data.status_id;
      this.export_invoices = response.data.export_invoices;
      */
    },
    fetchExportationFiles: async function () {
      let response =
        await BasicContainerExportMERequester.fetchExportationFiles(
          this.exportation_id
        );

      this.exportation_files = response.data;
    },
    fetchExportationAttachments: async function () {
      let response =
        await BasicContainerExportMERequester.fetchExportationAttachments(
          this.exportation_id
        );

      this.exportation_attachments = response.data.map(
        (exportation_attachment) => {
          return {
            ...exportation_attachment,
            downloading: false,
          };
        }
      );
    },
    exportationAttachments: function (exporter_process_exportation_file_id) {
      return this.exportation_attachments.filter(
        (exportation_attachment) =>
          exportation_attachment.exporter_process_exportation_file_id ===
          exporter_process_exportation_file_id
      );
    },
    goToShowProcess: function () {
      this.$router.push({
        name: this.routeName("show_process_exportations"),
        params: {
          agro_exporter_process_id: this.agro_exporter_process_id,
        },
      });
    },
    goToEditExportation: function () {
      this.$router.push({
        name: "ae_production_basic_container_export_edit_exportation_path",
        params: {
          agro_exporter_process_id: this.agro_exporter_process_id,
          exportation_id: this.exportation_id,
        },
      });
    },
    destroyExportation: async function () {
      this.proc_button_destroy = true;
      try {
        let response = await BasicContainerExportMERequester.destroyExportation(
          this.exportation_id
        );
        this.registerSuccessNotification({
          title: response.data.success_message,
        });
        this.goToShowProcess();
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields,
          });
        }
        this.proc_button_destroy = false;
      }
    },
    destroyExportationAttachment: async function (exportation_attachment) {
      try {
        var response =
          await BasicContainerExportMERequester.destroyExportationAttachment(
            exportation_attachment.id
          );
        this.registerSuccessNotification({
          title: response.data.success_message,
        });
        this.exportation_attachments.splice(
          this.exportation_attachments.indexOf(exportation_attachment),
          1
        );
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields,
          });
        }
      }
    },
    downloadReportExportation: async function () {
      this.downloading = true;
      var response =
        await BasicContainerExportMERequester.downloadExportationRepXlsx(
          this.exportation_id
        );
      const file = response.data;
      var fileURL = window.URL.createObjectURL(new Blob([file]));
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute(
        "download",
        "Sem_" +
        this.exportation.week +
        "_Reporte_de_Exportacion_" +
        this.exportation.booking_code +
        ".xlsx"
      );
      document.body.appendChild(fileLink);

      fileLink.click();
      this.downloading = false;
    },
    downloadExportationAttachment: async function (exportation_attachment) {
      exportation_attachment.downloading = true;
      var response =
        await BasicContainerExportMERequester.downloadExportationAttachment(
          exportation_attachment.id
        );
      const file = response.data;
      var fileURL = window.URL.createObjectURL(new Blob([file]));
      var fileLink = document.createElement("a");

      fileLink.href = fileURL;
      fileLink.setAttribute(
        "download",
        exportation_attachment.exportation_attach.blob.filename
      );
      document.body.appendChild(fileLink);

      fileLink.click();
      exportation_attachment.downloading = false;
    },
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id,
        },
      }).then(() => {
        this.fetchExportation();
        this.fetchExportationFiles();
        this.fetchExportationAttachments();
      })
    );
  },
};
</script>
